import { createFileRoute } from '@tanstack/react-router';

import { AnalyticsMoveReportPage } from '@pages/analytics';
import { ANALYTICS_MOVE_TAB_COURSES } from '@pages/analytics/ui/analytics-move-tabs';
import { Skeleton, Stack } from '@shared/ui';

export const Route = createFileRoute('/$locale/_authenticated/analytics-move/courses')({
  component: AnalyticsMoveCoursesRoute,
  pendingComponent: AnalyticsMoveCoursesPending,
  pendingMs: 0,
  pendingMinMs: 0,
});

function AnalyticsMoveCoursesRoute() {
  return <AnalyticsMoveReportPage activeTab={ANALYTICS_MOVE_TAB_COURSES} />;
}

function AnalyticsMoveCoursesPending() {
  return (
    <Stack gap="md" data-testid="analytics-courses-pending">
      <Skeleton className="h-10 w-72" />
      <Skeleton className="h-10 w-full" />
      <div className="space-y-3">
        {Array.from({ length: 4 }).map((_, index) => (
          <Skeleton key={`courses-pending-${String(index)}`} className="h-40 w-full" />
        ))}
      </div>
    </Stack>
  );
}
